export const fr = {
  title: `Conduite automobile`,
  p1: `La conduite automobile n’est pas interdite pour les personnes atteintes d’épilepsie. Néanmoins, il faut avoir un bon contrôle des crises pour être en mesure de reprendre le volant, car les personnes souffrant d’épilepsie qui ont des crises incontrôlées ne peuvent pas obtenir leur permis de conduire pour des raisons de sécurité. La conduite automobile représente donc généralement un facteur de motivation pour les personnes atteintes d’épilepsie à respecter les recommandations de leur médecin sur le contrôle des crises.`,
  p2: `Une fois le diagnostic d’épilepsie établi, il faut que la personne atteinte d’épilepsie (et non son médecin) fasse une déclaration à la Société d’Assurance Automobile du Québec (SAAQ). Il faut ainsi attendre un délai de 6 mois sans crise avant de pouvoir être en mesure d’obtenir ou de réobtenir son permis de conduire. Selon la recommandation d’un neurologue, ce délai de restriction peut s’avérer plus court.`,
  p3: `Il est important de respecter ces réglementations, car une personne épileptique qui conduit malgré le fait que son permis de conduire ait été révoqué par la SAAQ peut subir les sanctions suivantes : saisie du véhicule, contravention (amende de 300$ à 600$), révocation du permis de conduire et accusation au criminel.`,
  p4Before: `Pour d’autres informations concernant la conduite automobile, nous vous invitons à consulter `,
  p4After: `.`,
  p4Link: {
    text: `ce lien`,
    ref: `https://www.epilepsiequebec.com/WebSites/Epilepsie/Medias/La%20conduite%20automobile.pdf`
  },
  ss1: {
    title: `Informations spécifiques aux classes`,
    classes: {
      class5: {
        p1: `Classe 5:`,
        p2: `Après un diagnostic d’épilepsie où les crises s’accompagnent d’une altération de la conscience, il y a un délai de 6 mois sans conduite automobile.`,
        exceptions: {
          text: `Il existe des exceptions:`,
          bullets: [
            `Crises nocturnes exclusives sur une période de plus d’un an (voir la Loi sur l’assurance automobile du Québec, c. A-25)`,
            `Crises focales sans altération de conscience`,
            `Si lors d’un sevrage de médication prescrite par un médecin: 3 mois sans conduite au lieu de 6 mois`,
            `Première convulsion non-provoquée sans diagnostic d’épilepsie et les tests médicaux sont normaux: 3 mois sans conduite au lieu de 6 mois.`
          ]
        },
        p3: `Il est de la responsabilité du patient de déclarer son épilepsie à la SAAQ.`
      },
      class1To4: {
        title: `Classe 1-4 (véhicules lourds):`,
        bullets: [
          `L’épilepsie est essentiellement incompatible avec la conduite d’un véhicule lourd articulé, d’un autobus, d’un taxi, d’un véhicule d’urgence`,
          `Maintenant, le patient sans crise depuis plus de 5 ans a accès aux classes 1-4 au Canada seulement (depuis janvier 2010)`
        ],
        exceptions: {
          title: `Exceptions pour les classes 1-4:`,
          bullets: [
            `Crises focales sans altération de la conscience et sans impact sur la conduite sécuritaire d’un véhicule (délai de 3 ans du début)`,
            `Crises secondaires à l’arrêt ou modification de la médication par le médecin, et qu’il y avait plus de 5 ans sans crises auparavant (délai de 6 mois avec la reprise du traitement)`,
            `Crises groupées sur une période courte dans contexte de maladie intercurrente (délai de 6 mois sans crise)`
          ]
        }
      }
    }
  }
};
